import axios, { AxiosResponse } from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

export enum FilterType {
  Office = 'FILTER_OFFICE',
  Daily = 'FILTER_DAILY',
}

export async function patchUserWorkspaceSettings(user: any) {
  const { data } = await axios.patch(`${API_HOST}/v1/workspace`, {
    user,
  });
  return data;
}

export async function scheduleInterview(interview: any) {
  const { data } = await axios.post(`${API_HOST}/v1/interview`, interview);
  return data;
}

export async function patchUserPrivacySettings(user: any) {
  const { data } = await axios.patch(`${API_HOST}/v1/privacy`, {
    user,
  });
  return data;
}

export async function createJob(job: any) {
  const { data } = await axios.post(`${API_HOST}/v1/ats/vacancy`, { job });
  return data;
}

export async function offerVacancy(offer: any) {
  const { data } = await axios.post(`${API_HOST}/v1/ats/vacancy/offer`, {
    offer,
  });
  return data;
}

export async function createUser(user: any) {
  const { data } = await axios.post(`${API_HOST}/v1/people`, { user });
  return data;
}

export async function editWorkoff(workoff: any) {
  const { data } = await axios.patch(`${API_HOST}/v1/workoff`, { workoff });
  return data;
}

export async function updateUserLogo(logo: any) {
  const payload = logo?.formData || logo;
  const { data } = await axios.patch(`${API_HOST}/v1/workspace/logo`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

export async function deleteUserLogo() {
  const { data } = await axios.delete(`${API_HOST}/v1/workspace/logo`);
  return data;
}

export async function getWorkspaceLogo(): Promise<Blob | null> {
  try {
    const response = await axios.get(`${API_HOST}/v1/workspace/logo`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function dismissNotification(id: string | number) {
  const { data } = await axios.delete(`${API_HOST}/v1/notification/${id}`);
  return data;
}

export async function createTeam(team: any) {
  const { data } = await axios.post(`${API_HOST}/v1/team`, { team });
  return data;
}

export async function updateTeam(
  id: string,
  data: any,
): Promise<AxiosResponse> {
  const response = await axios.patch(`${API_HOST}/v1/team/${id}`, { data });
  return response;
}

export async function editUser(user: any) {
  console.log("EditUser called with:", user);
  try {
    const { data } = await axios.patch(`${API_HOST}/v1/people/${user.id}`, user);
    console.log("EditUser response:", data);
    return data;
  } catch (error) {
    console.error("Error in editUser:", error);
    // Re-throw to allow handling in the component
    throw error;
  }
}

// Add the Team interface definition
interface Team {
  id: string;
  name: string;
}

export async function getTeams(): Promise<Team[]> {
  // Adjust to expect the nested structure { status: string, data: Team[] }
  const response = await axios.get<{ status: string; data: Team[] }>(
    `${API_HOST}/v1/team`,
  );
  // Return the nested data array
  return response.data.data;
}
